import React from 'react';
import { Back, Banner } from '../../components';
import { Body, Wrapper, Facts, Content } from './Article.styled';

export default function Article({ title, date, image, children }) {
	return (
		<Wrapper>
			<Back title="Back to projects" />
			<Banner image={image} title={title} />
			<Content className="content">
				<Facts>
					<time>{date}</time>
				</Facts>
				<Body>{children}</Body>
			</Content>
		</Wrapper>
	);
}
